module.exports = "button {\r\n    width: 80px;\r\n    margin: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/assigment-cmp-databinding/game-control/game-control.component.css
// module id = ./src/app/components/assigment-cmp-databinding/game-control/game-control.component.css
// module chunks = main